import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { zAppDevTabViewComponent } from './tabView.component';
import { ZAppDevTabPanel } from './tabPanel.component';
import { TabsModule } from 'primeng/tabs';
import { RuleEngineModule } from 'src/app/@framework/rule-engine/rule-engine.module';

const COMPONENTS = [
  zAppDevTabViewComponent,
  ZAppDevTabPanel
];

@NgModule({
  imports: [
    CommonModule,
    TabsModule,
    RuleEngineModule,
    ...COMPONENTS,
  ],
  exports: [...COMPONENTS]
})
export class zAppDevTabContainerModule { }
